import {
  clearAgent,
  loadSingleAgent,
} from "@/redux/rtk/features/CRM/agent/agentSlice";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import CompanyInfo from "./CompanyInfo";
import CompanyProfile from "./CompanyProfile";

export default function DetailsCompany() {
  const { t } = useTranslation();
  const { id } = useParams();
  const dispatch = useDispatch();
  const { agent: company, loading: companyLoading } = useSelector(
    (state) => state.agent
  );

  useEffect(() => {
    dispatch(loadSingleAgent(id));
    return () => {
      dispatch(clearAgent());
    };
  }, [dispatch, id]);

  return (
    <div className="w-full min-h-screen">
      <div className="flex flex-col w-full p-2 sm:p-3 md:p-4 lg:p-6 gap-4 sm:gap-6">
        <div className="text-lg sm:text-xl lg:text-2xl font-semibold dark:text-white px-2 sm:px-0">
          {t("company.companyDetails")}
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm overflow-hidden text-center">
          <div className="p-2 sm:p-4">
            <div className="grid grid-cols-1 xl:grid-cols-3 gap-4 sm:gap-6">
              <div className="xl:col-span-1 order-2 xl:order-1">
                <CompanyProfile data={company} loading={companyLoading} />
              </div>
              <div className="xl:col-span-2 order-1 xl:order-2">
                <CompanyInfo data={company} loading={companyLoading} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
